import moment from 'moment';
import 'moment-timezone';

/**
 * Since of the frontend changes it is possible some closed exceptions can have date in
 * format D-M-YYYY.
 *
 * @param {number|string} timestamp Timestamp or date
 * @param {string} timezone Timezone
 * @returns {string} date in format D-M-YYYY
 */
export function parseDate(timestamp: number | string, timezone: string): string {
  if (typeof timestamp === 'number' || !isNaN(Number(timestamp))) {
    return moment(Number(timestamp)).tz(timezone).format('D-M-YYYY');
  }

  return timestamp; // It is a date in format D-M-YYYY, return it as is
}

export function convertDateToTimezone(date: string, newTimezone: string, format = 'D-M-YYYY'): number {
  return moment.tz(date, format, newTimezone).valueOf();
}

export function convertTimeToTimezone(
  time: number,
  oldTimezone: string,
  newTimezone: string,
  addDay = false,
  format = 'hh:mm A',
): number {
  const date = moment.tz(moment.tz(time, oldTimezone).format(format), format, newTimezone);
  if (addDay) {
    date.add(1, 'day');
  }

  return date.valueOf();
}
